import React from 'react';
import { getData, deleteData, } from '../../../core/HttpAction';
import Table from '../../../core/Table'; 
import {withRouter, Link} from 'react-router-dom';
import {permissionCheck} from '../../../core/Permission';

const Url='/fine';
const payUrl='fine-pay';
 
const CellColumn=({props,row})=>{ 
    return row.paid=='no' ? <button type="button" onClick={(e)=>{
        props.payFine(row.fine_id); 
    }} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Pay</button>
        :'Paid';
};
const columns=[
    {
        key:'book_name',
        displayName:'Book'
    }, 
    {
        key:'code',
        displayName:'Book Code'
    },
    {
        key:'member_name',
        displayName:'Name'
    }, 
    {
        key:'member_type',
        displayName: 'User Type'
    },
    {
        key:'amount',
        displayName:'Amount Per Day',
        styles:{width:'8%'}
    },
    {
        key:'total_amount',
        displayName:'Fine Amount',
        styles:{width:'8%'}
    },
    {
        key:'paid',
        displayName:'Status',
        Cell: permissionCheck('fine','Pay') ? CellColumn:''
    }//,
    /*{
        key:'paidon',
        displayName:'Paid Date',
        styles:{width:'8%'}
    },*/
    
];
  
class ListPage extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'', 
                limit:10,
                page:1
            }, 
            data:[],
            preloader:true,
        };
        this.fetchData = this.fetchData.bind(this);  
        this.handleFetch = this.handleFetch.bind(this);  
        this.delete = this.delete.bind(this);  
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData(){
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch(params){
        this.setState({params:{...params},preloader:true},()=>{
            this.fetchData();
        });
    }

    delete(id){
        let page=1;
        this.setState({preloader:true,params:{...this.state.params,page}});
        deleteData(Url+'/'+id).then((res)=>{
            if(res.data.status===200){
                this.fetchData();
            }else{
                alert('Not delete');
                this.setState({preloader:false});
            }
        });   
    }
    payFine(id){
        this.setState({preloader:true});
        getData(payUrl+'/'+id).then((res)=>{
            if(res.data.status===200){
                this.fetchData();
            }else{
                alert('Payment failed !...');
                this.setState({preloader:false});
            }
        });   
    }
 
    render() {
        let {preloader,data}=this.state; 
        return (
            <Table
                data={data}
                handleFetch={this.handleFetch.bind(this)}
                preloader={preloader}
                permission="fine"
                title="Fine"
                columns={columns}
                primaryKey="fine_id"
                addEditUrl={`${this.props.match.url}-action`} 
                delete={this.delete.bind(this)}
                payFine={this.payFine.bind(this)}
            /> 
        );
    }
}
 
export default  withRouter(ListPage); 



// WEBPACK FOOTER //
// ./src/components/Library/Fine/index.js